export class Agreement {
    agreedFlag: boolean;
    agreementId: string;
    agreementText: string;
    returnCode: string;
    version: string;
}
